import React from 'react';
import { getCSSVariableValue } from '../utils/getCSSVariableValue.js';

const backgroundColor = getCSSVariableValue('--bc-buttons');
const lineColor = getCSSVariableValue('--fc-buttons');

function MobileMenuOpen(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none" {...props}>
            <circle cx="25" cy="25" r="25" fill={backgroundColor}/>
                <line x1="36" y1="19.5" x2="13" y2="19.5" stroke={lineColor}/>
                <line x1="36" y1="31.5" x2="13" y2="31.5" stroke={lineColor}/>
        </svg>
    );
}

export default MobileMenuOpen;
